import React from 'react'
import SkeletonLoader from './SkeletonLoader'

interface AuthPreloaderProps {
  message?: string;
  showProgress?: boolean;
}

const AuthPreloader: React.FC<AuthPreloaderProps> = ({ 
    message = "Verifying your session...", 
    showProgress = true 
}) => {
  return (
    <div className="auth-preloader">
      <div className="auth-preloader-content">
        <div className="auth-preloader-logo">
          {/* Add your app logo here */}
          <div className="logo-placeholder">MyAssets</div>
        </div>
        
        {showProgress && (
          <div className="auth-preloader-progress">
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
          </div>
        )}
        
        <p className="auth-preloader-message">{message}</p>
        
        <div className="auth-preloader-spinner">
          <div className="spinner"></div>
        </div>
      </div>
    </div>
  )
}

export default AuthPreloader
